import React, { useEffect, useState } from "react";
// import { CheckoutPreviewSection } from './StyledComponents';
import { observer } from "mobx-react";
import { firstValueFrom } from "rxjs";
import styled from "styled-components";
import {
  DonationItem,
  MultipleItems,
  PurchasePayment,
  PurchaseSection,
  PurchaseSuccess,
  PurchaseTopBar,
  SingleItemMultiplePrices,
} from "../../../shared/components";
import {
  CustomLabel,
  FlexContainer,
  Loader,
  ToastService,
} from "@mindmemobile/mm-shared-global";
import {
  PurchaseColoredBackground,
  PurchaseWrapper,
} from "../../../shared/styles";
import { CheckOutStore, PurchaseStore } from "../../../shared/store";
import {
  AddressModel,
  DonationPricingPageInputsModel,
  PurchasePaymentIntentModel,
  PurchasePaymentModel,
} from "../../../shared/models";
import { AuthService, CheckOutService } from "../../../shared/services";
import {
  CheckoutColorType,
  CheckOutDisplayTypes,
  CheckOutPayButtonCaption,
  IFRAMEMessageTypes,
  UpsertCheckoutActiveStep,
  UpsertPurchaseActiveStep,
} from "../../../shared/enums";
import { ICheckOutCombinedColors } from "../../../shared/interfaces";
// import { CheckoutPreviewSection } from './StyledComponents';

const PreviewWrapper = styled.div`
  .purchase-middle-panel {
    ${PurchaseColoredBackground} {
      padding: 30px 20px;
    }
    .purchase-section {
      padding: 30px;
    }
    .divided-component {
      gap: 30px;
    }
    .item-right-panel {
      /* padding: 0px; */
    }
  }
  &.donation-preview-only {
    .donation-left-right-image {
      /* height: calc(100vh - 80px); */
      height: calc(100vh - 119px);
    }
    .donation-ad-block {
      max-height: calc(100vh - 150px);
    }
    .donation-img-wrapper {
      gap: 0px !important;
    }
    .purchase-wrapper-donation-payment {
      padding: 20px 10px !important;
    }
    .donation-img-bg-wrapper {
      height: calc(100vh - 142px);
    }
    /* .purchase-middle-panel{
      overflow-y: unset ;
    } */
  }

  .main-image-wrapper .carousel-inner {
    img,
    video {
      max-width: 230px !important;
    }
  }
  .purchase-main-btn.height-50:not(.purchase-default-btn) {
    margin: 0 auto;
  }
  @media (min-width: 769px) and (max-width: 1024px) {
    .wrapped-columns {
      flex-wrap: inherit;
      &.wrapped-max-width {
        max-width: 100%;
        margin: 0 auto;
      }
      .item-right-panel {
        align-items: flex-start;
      }
      .item-header + label {
        text-align: inherit;
      }
      .option-qty {
        justify-content: flex-start;
      }
    }
  }
`;
const CheckoutPreview = () => {
  const [checkoutStore, setCheckoutStore] = useState<CheckOutStore | null>(
    null
  );
  const [paymentIntent, setPaymentIntent] =
    useState<PurchasePaymentIntentModel | null>(null);
  const [loading, setLoading] = useState(false);
  const [action, setAction] = useState(null);

  const createPaymentIntent = async () => {
    if (!checkoutStore?.detailPage.selectedMerchantAccount) return;
    const result = await firstValueFrom(
      CheckOutService.createPaymentIntent(
        "None",
        AuthService.authData.accountId,
        null,
        {
          gateway: checkoutStore?.detailPage.selectedMerchantAccount.gateway,
          applicationId:
            checkoutStore?.detailPage.selectedMerchantAccount.applicationId,
          merchantAccountId:
            checkoutStore?.detailPage.selectedMerchantAccount.merchantAccountId,
          name: checkoutStore?.detailPage.selectedMerchantAccount.name,
        }
      )
    );

    if (!result.result) {
      ToastService.showError("Error in creating payment intent");
    } else {
      const intent = PurchasePaymentIntentModel.deserializeAPIModel(
        result.result
      );
      setPaymentIntent(intent);
    }
    setLoading(false);
  };

  useEffect(() => {
    const handleMessage = (event: any) => {
      try {
        if (!event?.data || typeof event?.data !== "string") return;

        const data = JSON.parse(event.data);
        if (data?.type !== IFRAMEMessageTypes.CheckOutPreviewData) return;

        const newCheckoutStore = new CheckOutStore(data.checkoutStore);
        const action = data.action;
        setAction(action);
        setCheckoutStore(newCheckoutStore);

        const message = {
          type: IFRAMEMessageTypes.PreviewMessageDataReceived,
        };
        window.parent.postMessage(JSON.stringify(message), "*");
      } catch (error) {
        console.error("Failed to parse data:", error);
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  useEffect(() => {
    if (
      checkoutStore?.activeStep === UpsertCheckoutActiveStep.Pay &&
      !paymentIntent
    ) {
      setLoading(true);
      createPaymentIntent();
    }
  }, [checkoutStore]);

  const getBrandingData = () => {
    if (!checkoutStore || !checkoutStore.optionsPage.brandingData) return null;
    return checkoutStore.optionsPage.brandingData;
  };

  const getColors = () => {
    const brandingData = getBrandingData();
    if (!brandingData) return null;

    switch (brandingData.selectedColorType) {
      case CheckoutColorType.BasicColor:
        return brandingData.basicColors.getBasicColors() as ICheckOutCombinedColors;
      case CheckoutColorType.CustomColor:
        return brandingData.customColors.getCustomColors() as ICheckOutCombinedColors;
    }
  };

  const getButtonCaption = () => {
    const brandingData = getBrandingData();
    if (!brandingData) return null;

    const { selectedColorType, basicColors, customColors } = brandingData;

    if (selectedColorType === CheckoutColorType.BasicColor) {
      return basicColors.payButtonType === CheckOutPayButtonCaption.Custom
        ? basicColors.buttonCustomCaption
        : CheckOutPayButtonCaption[basicColors.payButtonType];
    } else if (selectedColorType === CheckoutColorType.CustomColor) {
      return customColors.payButtonType === CheckOutPayButtonCaption.Custom
        ? customColors.buttonCustomCaption
        : CheckOutPayButtonCaption[customColors.payButtonType];
    }
  };

  const getButtonStyle = () => {
    const brandingData = getBrandingData();
    if (!brandingData) return null;

    const { selectedColorType, basicColors, customColors } = brandingData;

    if (selectedColorType === CheckoutColorType.BasicColor) {
      return basicColors.buttonStyleType;
    } else if (selectedColorType === CheckoutColorType.CustomColor) {
      return customColors.buttonStyleType;
    }
  };

  const getSellPage = () => {
    if (!checkoutStore) return null;
    const colors = getColors();
    const displayType = checkoutStore.customerFacingModel.displayType;
    let content;

    if (checkoutStore.customerFacingModel.isDonationOnly) {
      return getDonationOptions();
    }
    switch (displayType) {
      case CheckOutDisplayTypes.MultipleItemsInbundle:
      case CheckOutDisplayTypes.SingleItem:
        content = (
          <PurchaseSection
            item={checkoutStore.customerFacingModel.items[0]}
            purchaseStore={new PurchaseStore()}
            onPurchaseClick={() => {}}
            colors={colors}
            buttonCaption={getButtonCaption()}
            buttonStyle={getButtonStyle()}
          />
        );
        break;
      case CheckOutDisplayTypes.SingleItemWithMultiplePrices:
        content = (
          <SingleItemMultiplePrices
            purchaseStore={new PurchaseStore()}
            onPurchaseClick={() => {}}
            recommendedItem={checkoutStore?.sellPage.recommendedItem}
            items={checkoutStore.customerFacingModel.getSortedItems()}
            color={colors}
            buttonCaption={getButtonCaption()}
            buttonStyle={getButtonStyle()}
            customOption={checkoutStore.customerFacingModel.customOption}
          />
        );
        break;
      case CheckOutDisplayTypes.MultipleItems:
        content = (
          <MultipleItems
            purchaseStore={new PurchaseStore()}
            items={checkoutStore.customerFacingModel.getSortedItems()}
            recommendedItem={checkoutStore?.sellPage.recommendedItem}
            onPurchaseClick={() => {}}
            groupByBillingFrequency={
              checkoutStore.sellPage.groupByBillingFrequency
            }
            colors={colors}
            buttonCaption={getButtonCaption()}
            buttonStyle={getButtonStyle()}
            customOption={checkoutStore.customerFacingModel.customOption}
          />
        );
        break;
      default:
        content = null;
        break;
    }
    return content;
  };

  const getPaymentPage = () => {
    if (!checkoutStore || !paymentIntent) return null;
    const colors = getColors();
    return (
      <PurchasePayment
        allowedPaymentMethods={
          checkoutStore.customerFacingModel?.options?.selectedPaymentMethods ||
          []
        }
        merchantAccount={checkoutStore.customerFacingModel.merchantAccount}
        items={checkoutStore.customerFacingModel.items}
        payDetails={checkoutStore.paymentPageData}
        paymentSectionData={
          new PurchasePaymentModel({
            countryDetails: checkoutStore.countryStore.getUSCountry(),
            billingAddress: new AddressModel({
              countryDetails: checkoutStore.countryStore.getUSCountry(),
            }),
            shippingAddress: new AddressModel({
              countryDetails: checkoutStore.countryStore.getUSCountry(),
            }),
          })
        }
        action={action}
        countriesWithState={checkoutStore.countryStore.countriesWithState}
        addOns={[]}
        paymentIntent={paymentIntent}
        updateItems={() => {}}
        updateAddOns={() => {}}
        updatePaymentSectionData={() => {}}
        onPayClick={() => {}}
        onPaymentMethodIdUpdate={() => {}}
        color={colors}
      />
    );
  };

  const getAfterPayPage = () => {
    if (!checkoutStore) return null;
    const colors = getColors();
    return (
      <div className="flex-auto-grow purchase-confirmed purchase-chckout-preview">
        <div>
          <PurchaseSuccess
            afterPayDetails={checkoutStore.afterPayPage}
            isPreview={true}
            buttonBgColor={colors?.primary.rgba}
          />
        </div>
      </div>
    );
  };

  const getDonationOptions = () => {
    if (!checkoutStore) return null;
    return (
      <DonationItem
        customerFacingCheckOutDetails={checkoutStore.customerFacingModel}
        updateDonationPricingPageData={() => {}}
        onDonationClick={() => {}}
        isPreview={true}
      />
    );
  };

  const getContent = (activeStep: UpsertCheckoutActiveStep) => {
    switch (activeStep) {
      case UpsertCheckoutActiveStep.Sell:
        return getSellPage();
      case UpsertCheckoutActiveStep.Pay:
        return getPaymentPage();
      case UpsertCheckoutActiveStep.AfterPay:
        return getAfterPayPage();
      case UpsertCheckoutActiveStep.Options:
        return checkoutStore?.detailPage.isDonationOnly
          ? getDonationOptions()
          : getSellPage();
      default:
        return null;
    }
  };

  const getPreviewContent = () => {
    if (!checkoutStore) return null;
    const colors = getColors();
    // const isDonationOnly = checkoutStore.detailPage.isDonationOnly;
    const hasBrandingData =
      checkoutStore.customerFacingModel.options?.brandingData;
    const hasActiveStep = checkoutStore.activeStep;
    const hasLogo = checkoutStore.optionsPage.brandingData?.showLogo;
    const hasHelp = checkoutStore.optionsPage.brandingData?.showHelp;

    const hasLogoOrHelp = hasLogo || hasHelp;
    return (
      <PurchaseWrapper
        bgColor={colors?.pageBackground?.rgba}
        className={
          // checkoutStore.activeStep === UpsertCheckoutActiveStep.Pay &&
          `${
            checkoutStore.detailPage.isDonationOnly
              ? "purchase-wrapper-donation-payment"
              : hasLogoOrHelp
                ? "purchase-wrapper-help-logo"
                : ""
          } ${hasLogoOrHelp ? "" : "nav-flex-no-height"}`
        }
        padding="25px 15px"
      >
        <div className={`full-width`}>
          <PurchaseTopBar
            purchaseStore={new PurchaseStore()}
            onTabChange={() => {}}
            showLogo={hasLogo}
            showHelp={hasHelp}
            brandingData={hasBrandingData}
            activeStep={UpsertPurchaseActiveStep.Purchase}
            seller={checkoutStore.customerFacingModel.seller}
            isDonationOnly={checkoutStore.detailPage.isDonationOnly}
          />
        </div>
        {/* <CheckoutPreviewSection> */}

        <div className="purchase-middle-panel">
          <PurchaseColoredBackground
            outerColor={colors?.outerBackground?.rgba}
            outerBorder={colors?.outerBorder?.rgba}
            innerColor={colors?.innerBackground?.rgba}
            // innerColor="#f00" // remove this
            innerBorder={colors?.innerBorder?.rgba}
          >
            <div
              className={`purchase-section ${
                hasActiveStep === UpsertCheckoutActiveStep.Options &&
                checkoutStore.detailPage.isDonationOnly
                  ? "donation-purchase-section"
                  : hasActiveStep === UpsertCheckoutActiveStep.Pay &&
                      checkoutStore.detailPage.isDonationOnly
                    ? "donation-pay-padding"
                    : ""
              }
                                `}
              // style={{
              //     background: colors?.innerBackground?.rgba,
              //     borderColor: colors?.innerBorder?.rgba,
              // }}
            >
              {getContent(hasActiveStep)}
            </div>
          </PurchaseColoredBackground>
        </div>
        {/* Commented for now */}
        {/* <div>
          <FlexContainer justifyContent="center" alignItems="center" size={0}>
            <CustomLabel className="purchase-footer">
              Powered by MindMe Payments | Terms | Privacy
            </CustomLabel>
          </FlexContainer>
        </div> */}
        {/* </CheckoutPreviewSection> */}
      </PurchaseWrapper>
    );
  };

  if (loading) return <>{new Loader(true).loaderComponent}</>;
  return (
    <PreviewWrapper
      className={`preview-wrappper ${checkoutStore?.detailPage.isDonationOnly ? "donation-preview-only" : ""}`}
    >
      {checkoutStore ? getPreviewContent() : new Loader(true).loaderComponent}
    </PreviewWrapper>
  );
};

export default observer(CheckoutPreview);
